/* screens/auth/VerifyEmail.jsx — Подтверждение email (S12, /verify-email?uid&token).
   Автообработка ссылки при mount. Состояния loading/error/ok. ХЕНДОФФ → pages/auth/VerifyEmail.jsx.
   Бэк: невалидный/устаревший uid|token → 400 code='invalid_token' (catch → error); {ok:true} → ok.
   Данные через authReal (adapters/auth.js). */

import React from 'react';
import { Button } from '../../components/ui/Button.jsx';
import { Icon } from '../../components/ui/Icon.jsx';
import { ScreenHeader } from '../../components/ui/Metric.jsx';
import { Spinner } from '../../components/ui/Spinner.jsx';
import { useAuth } from '../../app/providers/AuthProvider.jsx';
import { authReal } from '../../lib/api/index.js';
import { RR } from '../../lib/router.jsx';
import { safeNext } from '../../lib/safeNext.js';

  const { useState, useEffect } = React;
  const { useNavigate, useSearchParams } = RR;

  function VerifyEmail() {
    const navigate = useNavigate();
    const [sp] = useSearchParams();
    const { login } = useAuth();
    const [phase, setPhase] = useState('loading'); // loading | ok | error
    // Письмо с публичной ссылки покупки (/buy/<тариф>): в ссылке есть адрес оплаты.
    // Сервер при первом подтверждении сразу входит (logged_in) — ведём прямо на
    // оплату, без второго круга «войдите» и поиска тарифа в настройках.
    const next = safeNext(sp.get('next'));
    const signinPath = next ? '/signin?next=' + encodeURIComponent(next) : '/signin';

    useEffect(() => {
      let alive = true;
      authReal.verifyEmail({ uid: sp.get('uid'), token: sp.get('token'), next })
        .then(async (data) => {
          if (!alive) return;
          if (data && data.logged_in && data.user && next) {
            await login(data.user);
            navigate(next, { replace: true });
            return;
          }
          setPhase('ok');
        })
        .catch(() => { if (alive) setPhase('error'); });
      return () => { alive = false; };
    }, []);

    if (phase === 'loading') {
      return (
        <div className="auth-form auth-status stack stack-12" aria-busy="true">
          <Spinner size="lg" />
          <ScreenHeader align="center" title="Подтверждаем адрес…" subtitle="Это займёт пару секунд." />
        </div>
      );
    }

    if (phase === 'error') {
      return (
        <div className="auth-form auth-status stack stack-16">
          <div className="auth-status__glyph auth-status__glyph--bad" aria-hidden="true"><Icon name="alert-circle" size={30} /></div>
          <ScreenHeader align="center" title="Ссылка недействительна"
            subtitle="Возможно, она устарела, уже использована или скопирована не полностью." />
          <div className="stack stack-8">
            <Button variant="primary" size="lg" className="full" onClick={() => navigate(signinPath)}>Перейти ко входу</Button>
            <Button variant="secondary" size="lg" className="full" onClick={() => navigate('/signup')}>Создать аккаунт</Button>
          </div>
        </div>
      );
    }

    return (
      <div className="auth-form auth-status stack stack-16">
        <div className="auth-status__glyph auth-status__glyph--ok" aria-hidden="true"><Icon name="check-circle" size={30} /></div>
        <ScreenHeader align="center" title="Email подтверждён." subtitle="Теперь можно войти в систему." />
        <Button variant="primary" size="lg" className="full" onClick={() => navigate(signinPath)}>Войти</Button>
      </div>
    );
  }

export { VerifyEmail };
